import React, { useState } from "react";
import { Input, Label, FormFeedback } from 'reactstrap';
const TextArea = ({ label, isrequired, row, ...props }) => {
    return (
        <>
            <div className="mb-3">
                <Label htmlFor="exampleFormControlTextarea5" className="form-label">{label}
                    {
                        isrequired &&
                        <i className='ri-asterisk ri-xs rq_error ms-1'></i>
                    }</Label>
                <textarea className="form-control form-control-sm" id="exampleFormControlTextarea5" rows={row != undefined ? row : "3"} {...props}></textarea>
                <FormFeedback type="invalid">
                    {props.error_msg}
                </FormFeedback>
            </div>
        </>
    );
};

export default TextArea;
